<template>
	<div>
		<div class="uk-margin-large-bottom">
			<nav class="uk-navbar-container" uk-navbar>
				<div class="uk-navbar-left">
					<h1 class="uk-navbar-item uk-logo">管理者ログイン</h1>
				</div>
			</nav>
		</div>
		<div class="uk-container">
			<div id="login_form" class="uk-form-horizontal">
				<div class="uk-margin">
					<label class="uk-form-label" for="form_horizontal_id">ID (必須)</label>
					<div class="uk-form-controls">
						<input class="uk-input" id="form_horizontal_id" name="id" type="text" placeholder="IDを入力してください">
						<p class="uk-alert-danger uk-padding-small" v-if="this.isLoginError">IDまたはパスワードが間違っています。</p>
					</div>
				</div>
				<div class="uk-margin">
					<label class="uk-form-label" for="form_horizontal_password">パスワード (必須)</label>
					<div class="uk-form-controls">
						<input class="uk-input" id="form_horizontal_password" name="password" type="password" placeholder="パスワードを入力してください">
						<p class="uk-alert-danger uk-padding-small" v-if="this.isLoginError">IDまたはパスワードが間違っています。</p>
					</div>
				</div>
				<div class="uk-margin">
					<button class="uk-width-1-1@l uk-button uk-button-large uk-button-primary" @click="onClickSubmit">ログイン</button>
				</div>
			</div>
		</div>
		<div class="uk-container uk-margin-large">
			<p class="uk-text-small uk-align-right">v{{APP_VERSION}}</p>
		</div>
	</div>
</template>

<script>
	import Role from '@/api/Role'
	import BranchOfficeAuth from '@/api/BranchOfficeAuth'
	import StaffAuth from '@/api/StaffAuth'
	import CallCenterAuth from '@/api/CallCenterAuth'
	import MainOfficeAuth from '@/api/MainOfficeAuth'


	export default {
		name: 'CallCenterLoginPage',
		data () {
			return {
				isLoginError: false
			}
		},
		computed: {
			APP_VERSION () {
				return APP_VERSION
			}
		},
		methods: {
			onClickSubmit () {
				let self = this

				let id = $('[name="id"]').val()
				let password = $('[name="password"]').val()

				let params = new URLSearchParams()
				params.append('id', id)
				params.append('password', password)

				CallCenterAuth.login(params).then(function (response) { // ログイン処理
					let data = response.data

					if (data.data == false) { // 失敗
						self.isLoginError = true
					} else { // 成功
						Role.show().then(function (response) { // 権限取得
							let data = response.data

							if (data.data.is_call_center === true) { // コールセンター
								// StaffAuth.logout().then(function (response) {
									// BranchOfficeAuth.logout().then(function (responase) {
										// MainOfficeAuth.logout().then(function (response) {
											document.title = '予約管理ツール【コールセンター】'
											self.$router.push('/shop_search')
										// })
									// })
								// })
							}

							return response
						})
					}
				})
			}
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/page/auth/CallCenterLoginPage.vue